import React from 'react';
import cn from 'classnames';
import Animation from '@/Framework/UI/Pages/Landing/Sections/Animation';
import styles from './introSmall.scss';

interface IProps {
  title: string,
  description?: React.ReactNode,
  className: string,
  classNameDescription?: string,
}

const Intro = ({ title, description, className, classNameDescription }: IProps) => (
  <div className={ cn(styles.intro, className) }>
    <div className={ styles.introContainer }>
      <h1 className={ styles.introTitle }>
        { title }
      </h1>
      { description && (
        <div className={ cn(styles.introDescription, classNameDescription) }>
          { description }
        </div>
      ) }
    </div>
    <Animation />
  </div>
);

export default Intro;
